'use client';

import { Suspense } from 'react';
import SharedLayout from '../../components/SharedLayout';
import PolicyPageLayout from '../components/PolicyPageLayout';

// Metadata is now handled in the layout.tsx file for this route

// Content component that will be wrapped in Suspense
function QualityPolicyContent() {
  return (
    <SharedLayout>
      <div className="container mx-auto px-4 py-8">
        <PolicyPageLayout
          title="Política de Calidad"
          lastUpdated="15 de Enero de 2023"
        >
          <p>
            En Droquimar, nos comprometemos a proporcionar productos químicos de la más alta calidad
            que cumplan o excedan los requisitos de nuestros clientes y las normativas aplicables.
            Nuestra política de calidad se basa en los siguientes principios:
          </p>
          
          <h2 className="text-xl font-semibold mt-6 mb-3">Compromiso con la Excelencia</h2>
          <p>
            Buscamos la excelencia en todos los aspectos de nuestras operaciones, desde la selección
            de proveedores hasta la entrega final al cliente. Implementamos rigurosos controles de
            calidad en cada etapa del proceso para asegurar que nuestros productos cumplan con las
            especificaciones establecidas.
          </p>
          
          <h2 className="text-xl font-semibold mt-6 mb-3">Sistema de Gestión de Calidad</h2>
          <p>
            Mantenemos un Sistema de Gestión de Calidad integral que
            nos permite:
          </p>
          <ul className="list-disc ml-6 space-y-2 mt-2">
            <li>Identificar y gestionar los procesos clave que afectan la calidad de nuestros productos</li>
            <li>Establecer objetivos medibles para evaluar nuestro desempeño</li>
            <li>Implementar acciones correctivas y preventivas para mejorar continuamente</li>
            <li>Asegurar la trazabilidad de todos nuestros productos</li>
            <li>Verificar la conformidad de nuestros productos con las especificaciones técnicas requeridas</li>
          </ul>
          
          <h2 className="text-xl font-semibold mt-6 mb-3">Capacitación del Personal</h2>
          <p>
            Invertimos en la formación continua de nuestro personal para asegurar que posean los
            conocimientos y habilidades necesarios para:
          </p>
          <ul className="list-disc ml-6 space-y-2 mt-2">
            <li>Manipular correctamente los productos químicos</li>
            <li>Realizar los controles de calidad establecidos</li>
            <li>Comprender y aplicar los procedimientos del sistema de gestión de calidad</li>
            <li>Responder eficazmente a situaciones no conformes</li>
          </ul>
          
          <h2 className="text-xl font-semibold mt-6 mb-3">Mejora Continua</h2>
          <p>
            Nos comprometemos con la mejora continua de nuestros procesos, productos y servicios.
            Regularmente:
          </p>
          <ul className="list-disc ml-6 space-y-2 mt-2">
            <li>Evaluamos la eficacia de nuestro sistema de gestión de calidad</li>
            <li>Analizamos la retroalimentación de nuestros clientes</li>
            <li>Monitoreamos las tendencias del mercado y los avances tecnológicos</li>
            <li>Implementamos innovaciones que añaden valor a nuestros productos y servicios</li>
          </ul>
          
          <h2 className="text-xl font-semibold mt-6 mb-3">Enfoque al Cliente</h2>
          <p>
            Entendemos que nuestro éxito depende de la satisfacción de nuestros clientes. Por lo tanto:
          </p>
          <ul className="list-disc ml-6 space-y-2 mt-2">
            <li>Nos esforzamos por comprender y anticipar sus necesidades</li>
            <li>Proporcionamos asesoramiento técnico especializado</li>
            <li>Ofrecemos soluciones personalizadas cuando sea necesario</li>
            <li>Respondemos rápidamente a sus consultas y requerimientos</li>
            <li>Evaluamos regularmente su satisfacción y actuamos sobre sus comentarios</li>
          </ul>
          
          <p className="mt-6">
            Esta política de calidad es comunicada a todos los empleados de Droquimar y revisada
            periódicamente para asegurar su continua idoneidad. Nos comprometemos a proporcionar
            los recursos necesarios para implementarla efectivamente en toda la organización.
          </p>
          
          <div className="mt-8 text-right">
            <p className="font-bold">La Gerencia</p>
          </div>
        </PolicyPageLayout>
      </div>
    </SharedLayout>
  );
}

// Fallback component for Suspense
function QualityPolicyFallback() {
  return (
    <div className="container mx-auto px-4 py-8">
      <div className="max-w-4xl mx-auto bg-white p-8 rounded-lg shadow-lg">
        <div className="animate-pulse">
          <div className="h-8 bg-gray-200 rounded w-1/3 mb-4"></div>
          <div className="h-4 bg-gray-200 rounded w-1/4 mb-8"></div>
          <div className="h-4 bg-gray-200 rounded w-full mb-4"></div>
          <div className="h-4 bg-gray-200 rounded w-full mb-4"></div>
          <div className="h-4 bg-gray-200 rounded w-3/4 mb-8"></div>
          
          <div className="h-6 bg-gray-200 rounded w-1/2 mb-4"></div>
          <div className="h-4 bg-gray-200 rounded w-full mb-4"></div>
          <div className="h-4 bg-gray-200 rounded w-full mb-4"></div>
          <div className="h-4 bg-gray-200 rounded w-5/6 mb-8"></div>
        </div>
      </div>
    </div>
  );
}

// Main component that wraps the content in Suspense
export default function QualityPolicyPage() {
  return (
    <Suspense fallback={<QualityPolicyFallback />}>
      <QualityPolicyContent />
    </Suspense>
  );
}